<template>
  <area-component
    :ad="Array.isArray(ad) ? {} : ad"
    :show-skeleton="showSkeleton"
    v-model="isLoading"
    @onRefresh="onRefresh"
    @loadData="loadData"
    :errorImg="require(`@/assets/img/pre-sell/bar_adver.png`)"
    title="预售专区"
    ref="areaComponent"
  >
    <div class="goods-list">
      <not-goods v-if="list.length === 0"></not-goods>
      <goods-item
        v-for="(item,index) in list"
        :item="item"
        :key="index"
        @click.native="toDetail(item)"
        :stockTag="getShowStock (item)"
        :bottom="false"
      >
        <template slot="time" v-if="item.countDown!==0">
          距开始:
          <span>{{item.countDown.d}}</span>天
          <span>{{item.countDown.h}}</span>时
          <span>{{item.countDown.m}}</span>分
          <span>{{item.countDown.s}}</span>秒
        </template>
        <template slot="btn">
          <goods-btn :btn-type="getGoodsType(item)" @openCart="openCart(item)" @openPreRemind="openPreRemind(item.presell_id)"/>
        </template>
      </goods-item>
    </div>
    <!-- 购物车弹窗start(有库存) -->
      <cc-shop-cart
        :isShowPopup="showcart"
        :cartItemData="cartItem"
        @close="showcart=false"
        getContainer="body"
        :height="556"
        :HeaderHight="88"
        ref="shopCart"
      ></cc-shop-cart>
    <!-- 购物车弹窗end -->
    <!-- 缺货弹窗start-->
    <!-- <div v-else-if="showCartOrNogoods">
      <cc-nogoods-remind
        :isShowPopup="showShowCart"
        :cartItem="cartItem"
        getContainer="body"
        :height="426"
        @close="showShowCart=false"
        ref="nogoods"
      ></cc-nogoods-remind>
    </div> -->
    <cc-bottom-popup
      title="预售提醒"
      getContainer='body'
      :autoHeight="true"
      :height="556"
      @close="preRemindShow=false"
      :isShowPopup="preRemindShow"
      @subBtn="preRemind"
    >
      <div class="preRemind-box">
        <p>预售通知手机号：</p>
        <input type="text" v-model="mobile" />
      </div>
    </cc-bottom-popup>
  </area-component>
</template>
<script>
import CartStepMixin from '@/mixins/cartStep'
import CommandMixin from '@/mixins/command'
import ListMixin from '@/mixins/list'
import NotGoods from '../components/not-goods'
import GoodsItem from '../components/item-component'
import { loadPresellGoods, presellSms } from '@/fetch/pre-sell/index.js'
import AreaComponent from '../components/area-component'
import GoodsBtn from '../components/btn'
import CountDownMixin from '@/mixins/countDown'

import Vue from 'vue'
import { List, Icon, Toast } from 'vant'

Vue.use(Icon)
  .use(List)
  .use(Toast)
export default {
  mixins: [ListMixin, CartStepMixin, CommandMixin, CountDownMixin],
  data () {
    return {
      showSkeleton: true,
      ad: null,
      isLoading: false,
      list: [],
      preRemindShow: false,
      mobile: '',
      // 该客户是否开户手机
      presell_message_set: ''
    }
  },
  components: {
    NotGoods,
    GoodsItem,
    AreaComponent,
    GoodsBtn
  },
  computed: {
    areaComponent () {
      return this.$refs.areaComponent
    },
    getShowStock () {
      return function (item) {
        if (this.getLoginStatus.data.member_id && +item.presell_stock === 0) {
          // 登录
          // 无预售库存
          return 3
        } else {
          return 1
        }
      }
    }
  },
  async created () {
    this.$nextTick(() => {
      this.loadData()
    })
  },
  methods: {
    toDetail (item) {
      this.$router.push({
        path: '/goods-details',
        query: {
          goods_id: item.id,
          type: item.for_type
        }
      })
    },
    getGoodsType (item) {
      if (this.getLoginStatus.data.member_id) { // 登录
        if (item.is_view === 1) { // 区域经销
          return 1
        } else if (+item.presell_stock === 0) { // 无预售库存
          return 7
        } else if (item.countDown !== 0) {
          // 活动未开始，根据倒计时来判断
          return 8
        } else {
          return 6
        }
      } else {
        return 6
      }
    },
    judgeTime (item) {
      return parseInt(+item.start_time - +item.now_time)
    },
    onRefresh () {
      this.areaComponent.mReset()
      this.loadData(true)
    },
    async loadData (reset) {
      this.areaComponent.mRequest()
      var params = {
        page: this.areaComponent.m_page.curr,
        limit: this.areaComponent.m_page.limit
      }
      let res = await loadPresellGoods(params)
      this.$tips(res, { tip: false }, res => {
        if (this.showSkeleton) {
          this.showSkeleton = false
        }
        this.isLoading = false
        const data = res
        this.ad = data.ad
        this.presell_message_set = data.presell_message_set
        if (data.presell_goods_arr.length === 0) {
          this.areaComponent.mEnd('--我也是有底线的--')
          if (reset) {
            this.list = []
          }
          if (this.list.length === 0) {
            this.areaComponent.m_finishedText = ''
          }
        } else {
          if (reset) {
            this.list = data.presell_goods_arr
          } else {
            this.list.push(...data.presell_goods_arr)
          }
          this.list.forEach(item => {
            if ((+item.start_time - +item.now_time) <= 0) {
              this.$set(item, 'countDown', 0)
            } else {
              this.$set(item, 'countDown', {
                d: '',
                h: '',
                m: '',
                s: ''
              })
              this.countDown(item)
            }
          })
          this.addGoodField(this.list)
        }
        this.areaComponent.mSuccess()
      })
    },
    openCart (item) {
      this.cartBtnAlter(item)
    },
    async preRemind () {
      if (!/^1[3456789]\d{9}$/.test(this.mobile)) {
        Toast('手机号码有误！')
        return false
      } else {
        let res = await presellSms({
          presell_id: this.presell_id,
          mobile: this.mobile
        })
        Toast(res.info.msg)
        setTimeout(() => {
        // 点击编辑时，企业类型增加一个未设置
          this.preRemindShow = false
          // this.height = '50vh'
        }, 200)
      }
    },
    openPreRemind (PresellId) {
      if (this.presell_message_set === '1') {
        this.preRemindShow = true
        this.presell_id = PresellId
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.header {
  /deep/ {
    background: #ffffff !important;
    color: #333333 !important;
    .left-arrow {
      color: #333333 !important;
    }
  }
  .ellipsis {
    width: 50%;
    height: 100%;
    @include center();
    transform: translateX(-5px);
    &-icon {
      transform: rotate(90deg);
    }
  }
}
.banner {
  img {
    width: 375px;
    height: 130px;
  }
}
.preRemind-box{
  margin:5px 20px 0 10px;
  p{
    font-size: 12px;
    line-height: 22px;
  }
  input{
    height: 40px;
    width:100%;
    background:#F7F6F6;
    border:0;
    margin-top:10px;
    border-radius: 4px;
    padding: 0 0 0 10px;
  }
}
</style>
